import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { ENV_CONFIG } from "../config/global.config";
import { authServiceApi } from "./apis/authService.api";
import { courseServiceApi } from "./apis/courseService.api";
import { employeeServiceApi } from "./apis/employeeService.api";
import { orderServiceApi } from "./apis/orderServiceApi";
import { invalidateAllTags } from "./app.middleware";
import { authReducer } from "./features/auth/auth.slice";

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    [authServiceApi.reducerPath]: authServiceApi.reducer,
    [employeeServiceApi.reducerPath]: employeeServiceApi.reducer,
    [courseServiceApi.reducerPath]: courseServiceApi.reducer,
    [orderServiceApi.reducerPath]: orderServiceApi.reducer,
    auth: authReducer,
  },
  devTools: ENV_CONFIG.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authServiceApi.middleware)
      .concat(employeeServiceApi.middleware)
      .concat(courseServiceApi.middleware)
      .concat(orderServiceApi.middleware)
      .concat(
        invalidateAllTags([
          authServiceApi,
          employeeServiceApi,
          courseServiceApi,
          orderServiceApi,
        ])
      ),
});

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
